export default {
    default: "系统错误，服务不可用",
    'IT-500': "接口信息配置错误，请联系管理员。",
    'Redis_Timeout': '缓存服务器连接超时',
    404: "接口不存在。",
    403: "接口权限不足。",
    503: "服务不可用。",
    500: "服务器应用程序内部错误。"
};
